import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmailChange() {
  const [params] = useSearchParams();
  const { verifyEmailChange } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [msg, setMsg] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setStatus("error"); setMsg("Missing verification token."); return; }
    verifyEmailChange(token)
      .then((u) => { setStatus("success"); setMsg(u?.email || ""); setTimeout(() => navigate("/dashboard"), 1800); })
      .catch((e) => { setStatus("error"); setMsg(e?.response?.data?.detail || "This link is invalid or has expired."); });
  }, []);

  return (
    <div className="bg-navy grain min-h-[70vh] flex items-center justify-center px-4" data-testid="verify-email-change-page">
      <div className="bg-white rounded-lg border border-border p-10 max-w-md w-full text-center">
        {status === "loading" && (<><Loader2 className="h-10 w-10 text-gold mx-auto animate-spin" /><p className="text-slate-600 mt-4">Confirming your new email…</p></>)}
        {status === "success" && (<>
          <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-navy mt-4">Email updated</h1>
          <p className="text-slate-600 mt-2">Your email is now <strong>{msg}</strong>. Redirecting to your profile…</p>
        </>)}
        {status === "error" && (<>
          <XCircle className="h-12 w-12 text-red-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-navy mt-4">Couldn't update email</h1>
          <p className="text-slate-600 mt-2">{msg}</p>
          <Link to="/dashboard" className="inline-block mt-6 h-10 px-5 leading-10 rounded-md bg-navy text-white text-sm font-semibold hover:bg-navy-light transition-colors">Back to profile</Link>
        </>)}
      </div>
    </div>
  );
}
